import {
    Card,
    CardBody,
    Input,
    TableRow,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
    Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import OnewayPickupPeriodicHikeDayTable from 'components/onewaypickupPeriodicHikeDay/OnewayPickupperiodicHikeDayTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import OnewayPickupPeriodicHikeDayServices from 'services/OnewayPeriodicHikeDayServices';
import { FiPlus } from 'react-icons/fi';
import OnewayPeriodicHikeDayDrawer from 'components/drawer/OnewayPeriodicHikeDayDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';

import sidebar from 'routes/sidebar';

const OnewayPickupPeriodicHikeDay = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer } = useContext(SidebarContext);
    const [status, setStatus] = useState('');
    const { title, serviceId } = useToggleDrawer();
    const { data, loading, error } = useAsync(
        OnewayPickupPeriodicHikeDayServices.getAllONewayPickupPeriodicHikeDay
    );

    const isDataArray = Array.isArray(data?.data); // Check if data is an array
    const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

    const isAdmin = adminInfo?.id === 1;

    const hideView = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'oneway periodic hike' && perm.view === 1
    );
    const hideDelete = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway periodic hike' && perm.delete === 1
    );

    const hideEdit = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'oneway periodic hike' && perm.edit === 1
    );

    const hideAdd = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'oneway periodic hike' && perm.add === 1
    );

    const hideExport = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway periodic hike' && perm.export === 1
    );
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const {
        onewayPickupHideDayRef,
        serviceData,
        dataTable,
        handleSubmitOnewayPickupPeriodicHikeDay,
        currentPage,
    } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);

    const updatedData = safeData.map(({ id, ...rest }) => rest);

    useEffect(() => {
        if (serviceData.length !== 0) {
            setItemsPerPage(serviceData.length);
        }
    }, [serviceData]);

    useEffect(() => {
        if (data?.status) {
            setStatus(data.status);
        } else {
            setStatus(false);
        }
    }, [data?.status]);


    const finalData = data?.data?.map((item, itemIndex) => {
        const vehicleIds = item.vehicle_type_id || [];
        const vehicleNames = item.vehicle_type_names || {};

        const vehicleTypes = vehicleIds
            .map((vid) => vehicleNames[vid] || vid)
            .join("\n");

        const hike = vehicleIds
            .map((vid) => {
                const val = item.hike?.[vid];
                return val ? `${val}%` : "";
            })
            .join("\n");


        return {
            "SI.No": itemIndex + 1,
            "From City": item.from_city_name,
            "To_City":item.to_city_name,
            "Start Date": item.start_date,
            "End Date": item.end_date,
            "Vehicle Type": vehicleTypes,
            "Hike": item.hike,
        };
    });
    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <MainDrawer>
                        <OnewayPeriodicHikeDayDrawer id={serviceId} />
                    </MainDrawer>

                    <PageTitle sidebar={sidebar().sidebar} />

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <div className="flex gap-6 items-center">
                                <div className="flex-1">
                                    <Input
                                        ref={onewayPickupHideDayRef}
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        placeholder="Quick Search"
                                        autoComplete="off"
                                        onChange={handleSubmitOnewayPickupPeriodicHikeDay}
                                    />
                                </div>

                                {hideAdd && (
                                    <Button
                                        onClick={toggleDrawer}
                                        className="w-56 rounded-md h-10"
                                    >
                                        <span className="mr-3">
                                            <FiPlus />
                                        </span>
                                        Add Periodic Day Rate
                                    </Button>
                                )}

                                {hideExport && (
                                    <ExportDataXlsx
                                        exportDataXlsx={finalData}
                                        fileNames="Airport Pickup Periodic Hike Day"
                                    />
                                )}
                            </div>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {serviceData.length ? (
                            <TableContainer>
                                <div
                                    className="overflow-y-scroll"
                                    style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
                                >
                                    <Table>
                                        <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                                            <TableRow>
                                                <TableCell>Sl.No.</TableCell>
                                                <TableCell>From City</TableCell>
                                                <TableCell>To City</TableCell>
                                                <TableCell>Start Date</TableCell>
                                                <TableCell>End Date</TableCell>
                                                <TableCell>Vehicle Type</TableCell>
                                                <TableCell>Hike (%)</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHeader>
                                        <OnewayPickupPeriodicHikeDayTable
                                            OnewayPickupBasicRate={serviceData}
                                            perpage={itemsPerPage}
                                            currentPage={currentPage}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </Table>
                                </div>
                            </TableContainer>
                        ) : (
                            <>
                                {data.status !== true ? (
                                    <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                                ) : (
                                    <NotFound title="There are no Oneway Pickup Periodic Hike Day." />
                                )}
                            </>
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default OnewayPickupPeriodicHikeDay;
